export const DEFAULT_PERMISSIONS = []
